var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs',{attrs:{"slider-color":"primary","show-arrows":"","background-color":"#e6e6e6","align-with-title":"","height":"75"}},_vm._l((_vm.reportMenu),function(item,index){return _c('v-tab',{key:index,attrs:{"to":item.to}},[_vm._v(" "+_vm._s(item.text)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }